"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.separateTrailingSpaces = exports.mergeAdjacentTextsWithString = exports.mergeAdjacentTexts = exports.assertAllELsHaveRange = exports.enumAllELs = void 0;
const controls_1 = require("../../node/el/controls");
const el_1 = require("../../node/el");
const enumAllELs = (el) => {
    const result = [];
    if (el instanceof el_1.EL) {
        result.push(el);
        result.push(...el.children.map(exports.enumAllELs).flat());
    }
    return result;
};
exports.enumAllELs = enumAllELs;
const assertAllELsHaveRange = (elOrELs) => {
    for (const el of (elOrELs instanceof el_1.EL ? [elOrELs] : elOrELs).map(exports.enumAllELs).flat()) {
        if (!el.range) {
            throw new Error(`${el.tag} has no range`);
        }
    }
};
exports.assertAllELsHaveRange = assertAllELsHaveRange;
// export const cancelPointerRanges = (inline: SentenceChildEL[]): SentenceChildEL[] => {
//     const result: SentenceChildEL[] = [];
//     for (const el of inline) {
//         if (el instanceof __Ranges) {
//             result.push(new __Text(el.text(), el.range));
//         } else {
//             const newEL = el.copy(false) as SentenceChildEL;
//             newEL.children = el.children.map(c => typeof c === "string" ? [c] : cancelPointerRanges([c as SentenceChildEL])).flat();
//             result.push(newEL);
//         }
//     }
//     return result;
// };
const mergeAdjacentTexts = (inline) => {
    return (0, exports.mergeAdjacentTextsWithString)(inline);
};
exports.mergeAdjacentTexts = mergeAdjacentTexts;
const mergeAdjacentTextsWithString = (inline) => {
    const result = [];
    for (const item of inline) {
        const lastItem = result.slice(-1)[0];
        if ((typeof lastItem !== "string")
            && lastItem?.tag === "__Text"
            && (typeof item === "string" || item.tag === "__Text")) {
            const itemText = typeof item === "string" ? item : item.text();
            const itemRange = typeof item === "string" ? (lastItem.range ? [lastItem.range[1], lastItem.range[1] + itemText.length] : null) : item.range;
            const replacedTail = new controls_1.__Text(lastItem.text() + itemText, ((lastItem.range && itemRange) ? [lastItem.range[0], itemRange[1]] : null));
            result.splice(-1, 1);
            result.push(replacedTail);
        }
        else if (typeof item === "string") {
            result.push(new controls_1.__Text(item, ((lastItem && lastItem.range) ? [lastItem.range[0], lastItem.range[1] + item.length] : null)));
        }
        else {
            result.push(item);
        }
    }
    return result.filter(r => !((r instanceof controls_1.__Text) && r.children[0] === ""));
};
exports.mergeAdjacentTextsWithString = mergeAdjacentTextsWithString;
const separateTrailingSpaces = (inline) => {
    const ret = { inline: (0, exports.mergeAdjacentTextsWithString)(inline), spaces: "" };
    if (ret.inline.slice(-1)[0]?.tag === "__Text") {
        const m = /^(.*?)(\s+)$/.exec(ret.inline.slice(-1)[0].text());
        if (m) {
            const orig = ret.inline.splice(-1, 1);
            if (m[1] !== "") {
                ret.inline.push(new controls_1.__Text(m[1], orig[0].range && [orig[0].range[0], orig[0].range[0] + m[1].length]));
            }
            ret.spaces = m[2];
        }
    }
    return ret;
};
exports.separateTrailingSpaces = separateTrailingSpaces;
//# sourceMappingURL=util.js.map